import React ,{ useEffect }from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserProfile } from "./UserProfile";
import { BrowserSessions } from "./BrowserSessions";
import { PasswordUpdate } from "./PasswordUpdate";
import { TwoFactorAuthentication } from "./TwoFactorAuthentication";
import { DeleteAccount } from "./DeleteAccount";
import { onUserProfileLoad } from "../../../store/Settings/actions";
import Loading from "../../../components/Loading";

export const SigninSecurity = (props) => {
    const dispatch = useDispatch();

    useEffect(()=>{dispatch(onUserProfileLoad())},[])

    const {loading} = useSelector(({settings}) => ({loading: settings.loading}));

    return (
        <Loading loading={loading}>
            <div className="flex gap-2">
                <div className="flex flex-col w-5/12 gap-2">
                    <UserProfile/>
                    <BrowserSessions/>
                    <DeleteAccount/>
                </div>
                <div className="flex flex-col w-5/12 gap-2">
                    <PasswordUpdate />
                    <TwoFactorAuthentication />
                </div>
            </div>
        </Loading>
        
    );
};
